'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _knob = require('./knob.directive');

var _knob2 = _interopRequireDefault(_knob);

var _switch = require('./switch.directive');

var _switch2 = _interopRequireDefault(_switch);

var _roundSwitch = require('./round-switch.directive');

var _roundSwitch2 = _interopRequireDefault(_roundSwitch);

var _ledIndicator = require('./led-indicator.directive');

var _ledIndicator2 = _interopRequireDefault(_ledIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.widgets.rpc', [_knob2.default, _switch2.default, _roundSwitch2.default, _ledIndicator2.default]).name;


// WEBPACK FOOTER //
// ./src/app/widget/lib/rpc/index.js